import React, {useContext, useMemo} from 'react';
import moment from 'moment';
import ReactTable from 'react-table';

import Button from '../../../elements/CustomButton/CustomButton';
import useTideTable from '../../../hooks/table/useTideTable';
import {SecurityContext} from '../../../utils/SecurityManager';
import {
    formatRequirementDate,
    requirementBadgeStyle
} from '../../../utils/modelUtils/technology/developmentRequirementUtils';

const requestOptions = {
    customProp: 'developmentRequirements'
};

const DevelopmentRequests = ({history}) => {
    const security = useContext(SecurityContext);

    const columns = useMemo(() => [
        {
            Header: 'Folio',
            accessor: 'folio',
            id: 'id',
            filterable: false,
            width: 120
        },
        {
            Header: 'Título',
            accessor: 'title',
            id: 'title',
            filterable: true
        },
        {
            Header: 'Sistema',
            accessor: requirement =>
                requirement.system
                    ? requirement.system.name
                    : 'Sin sistema',
            id: 'system.code',
            filterable: true
        },
        {
            Header: 'Prioridad',
            accessor: requirement => (
                <span style={requirementBadgeStyle(requirement.priority)}>
                    {requirement.priority
                        ? requirement.priority.name
                        : 'Sin prioridad'}
                </span>
            ),
            id: 'priority.code',
            filterable: true,
            width: 130
        },
        {
            Header: 'Estado',
            accessor: requirement => (
                <span style={requirementBadgeStyle(requirement.status)}>
                    {requirement.status
                        ? requirement.status.name
                        : 'Sin estado'}
                </span>
            ),
            id: 'status.code',
            filterable: true,
            width: 140
        },
        {
            Header: 'Fecha deseada',
            accessor: requirement =>
                formatRequirementDate(
                    requirement.desiredDate,
                    moment
                ),
            id: 'desiredDate',
            filterable: false,
            width: 130
        },
        {
            Header: 'Creación',
            accessor: requirement =>
                requirement.createdDate
                    ? moment(requirement.createdDate).format(
                        'DD/MM/YYYY HH:mm'
                    )
                    : 'Sin fecha',
            id: 'createdDate',
            filterable: false,
            width: 160
        }
    ], []);

    const table = useTideTable({
        entity: 'developmentRequirements',
        columns,
        requestOptions
    });

    const goToDetail = requirement => {
        if (!requirement) {
            return;
        }

        history.push(
            `/technology/development-requests/${requirement.id}`
        );
    };

    const goToCreate = () => {
        history.push('/technology/development-requests/new');
    };

    return (
        <div className="DevelopmentRequests container-fluid main-container">
            <div className="row">
                <div className="col-xs-12">
                    <h2>Solicitudes de Desarrollo</h2>
                    <p className="text-muted">
                        Registro, evaluación y seguimiento de
                        requerimientos tecnológicos.
                    </p>
                </div>
            </div>

            {security.technology.canCreateDevelopmentRequests() ? (
                <Button
                    bsStyle="primary"
                    className="pull-right"
                    onClick={goToCreate}
                >
                    Nuevo requerimiento
                </Button>
            ) : null}

            <div className="clearfix" />

            <ReactTable
                {...table.tableProps}
                getTdProps={(state, row) => ({
                    onClick: () =>
                        row ? goToDetail(row.original) : null,
                    style: {
                        cursor: row ? 'pointer' : 'default'
                    }
                })}
            />

            <p className="total-count">
                {table.itemsFoundString}
            </p>
        </div>
    );
};

export default DevelopmentRequests;
